import React, { useEffect, useRef } from "react";
import FixedWidgetContainer from "components/common/FixedWidgetContainer";
import { FiBell, FiArrowUp } from "react-icons/fi";

function SaveChangedHintWidget({ diffCount, bottom, right }) {
  const originalTitleRef = useRef("");

  useEffect(() => {
    if (!originalTitleRef.current) {
      const currentTitle = document.title;
      const match = currentTitle.match(/^\*Unsaved(?: \(\d+\))?\*\s*(.*)$/);
      const extracted = match ? match[1] : currentTitle;
      originalTitleRef.current = extracted || "YB Observer";
    }

    let isShowingAlert = true;
    document.title = `*Unsaved (${diffCount})*`;

    const intervalId = setInterval(() => {
      isShowingAlert = !isShowingAlert;
      document.title = isShowingAlert
        ? `*Unsaved (${diffCount})*`
        : originalTitleRef.current;
    }, 1500);

    return () => {
      clearInterval(intervalId);
      document.title = originalTitleRef.current;
    };
  }, [diffCount]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <FixedWidgetContainer bottom={bottom} right={right}>
      <div className="pointer-events-auto flex items-center rounded bg-orange-400 px-5 py-2 text-sm text-white shadow-md">
        <div>
          <FiBell className="mr-2 inline-block text-lg" />
          Unsaved changes{" "}
          <span className="font-semibold">({diffCount})</span>
        </div>
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="group ml-2 flex items-center rounded-full px-2 py-1 text-sm font-medium border border-orange-300 hover:bg-orange-300 hover:text-orange-900 transition-all focus:outline-none"
          title="Go to top"
        >
          <FiArrowUp className="mr-1" />
          Click save to apply
        </button>
      </div>
    </FixedWidgetContainer>
  );
}

export default SaveChangedHintWidget;
